import React, { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import { fetchTerms } from '../services/airtableService';
import './Terms.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Terms = () => {
  const [termsData, setTermsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stylesLoaded, setStylesLoaded] = useState(false);

  useEffect(() => {
    // CSS 로딩 완료 확인
    const checkStylesLoaded = () => {
      const testElement = document.createElement('div');
      testElement.className = 'terms-container';
      testElement.style.display = 'none';
      document.body.appendChild(testElement);
      
      const computedStyle = window.getComputedStyle(testElement);
      const isLoaded = computedStyle.writingMode === 'horizontal-tb';
      
      document.body.removeChild(testElement);
      return isLoaded;
    };

    // 스타일 로딩 확인
    const checkStyles = () => {
      if (checkStylesLoaded()) {
        setStylesLoaded(true);
        // DOM에 클래스 추가하여 CSS 트랜지션 활성화
        setTimeout(() => {
          const container = document.querySelector('.terms-container');
          if (container) {
            container.classList.add('styles-loaded');
          }
        }, 100);
      } else {
        setTimeout(checkStyles, 50);
      }
    };

    // 즉시 확인 후 주기적으로 체크
    checkStyles();

    const loadTerms = async () => {
      try {
        setLoading(true);
        const data = await fetchTerms();
        setTermsData(data);
      } catch (err) {
        console.error('Terms 약관 로드 실패:', err);
        setError('이용약관을 불러오는 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, []);

  const containerClassName = `terms-container${stylesLoaded ? ' styles-loaded' : ''}`;

  // 스타일이 로드되지 않았거나 데이터 로딩 중일 때는 빈 화면 표시
  if (loading || !stylesLoaded) {
    return (
      <div className={containerClassName} style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{ 
          textAlign: 'center',
          color: '#666',
          fontSize: '1.1rem'
        }}>
          {loading ? '로딩 중...' : '스타일 로딩 중...'}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={containerClassName}>
        <div className="terms-content">
          <div className="error">
            <h1 style={{
              display: 'block',
              writingMode: 'horizontal-tb',
              textOrientation: 'mixed',
              direction: 'ltr',
              whiteSpace: 'normal',
              wordBreak: 'keep-all',
              flexDirection: 'unset',
              flexWrap: 'unset'
            }}>이용약관</h1>
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>다시 시도</button>
          </div>
        </div>
      </div>
    );
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '이용약관 - Flowto.AI',
    description: 'Flowto.AI 이용약관',
    url: 'https://flowto-ai.com/terms'
  };

  return (
    <div className={containerClassName}>
      <SEO
        title="이용약관"
        description="Flowto.AI 이용약관"
        url="/terms"
        type="website"
        structuredData={structuredData}
      />
      <div className="terms-content">
        <header className="terms-header" style={{
          writingMode: 'horizontal-tb',
          textOrientation: 'mixed',
          direction: 'ltr'
        }}>
          <h1 style={{
            display: 'block',
            writingMode: 'horizontal-tb',
            textOrientation: 'mixed',
            direction: 'ltr',
            whiteSpace: 'normal',
            wordBreak: 'keep-all',
            flexDirection: 'unset',
            flexWrap: 'unset'
          }}>이용약관</h1>
          {termsData?.lastModified && (
            <p className="last-updated">
              최종 수정일: {new Date(termsData.lastModified).toLocaleDateString('ko-KR')}
            </p>
          )}
        </header>
        
        <div className="terms-body">
          {termsData ? (
            <div className="terms-content-text">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{termsData}</ReactMarkdown>
            </div>
          ) : (
            <p>이용약관 내용이 없습니다.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Terms;
